<template>
  <div class="col-12 col-lg-5 justify-content-end d-flex pt-3 right-container">
    <div class="casedrive-side-panel">
        <div class="pb-2 mb-5 mb-xl-4" v-if="userToken === null">
            <button @click="onOpenInCaseDrive()" class="btn btn-primary show-cd-btn">Open in CaseDrive <img src="@/sass-template/content/images/long-arrow-right-regular.svg" /></button>
        </div>

        <!-- Download App -->
        <div class="download-app-section card mt-3">
            <div class="download-app-inner">
                <img src="@/sass-template/content/images/casedrive-logo.svg" class="img-fluid mb-4" alt="">
                <div class="text-content">
                  <h2 class="title mb-3 mt-1">Download the CaseDrive app on your phone.</h2>
                  <h4 class="title mb-4">
                      <span class="d-none d-lg-inline">Create and unleash your own database of professional content.</span>
                      <span class="d-lg-none">Create. Organize. Share. Discuss.</span>
                  </h4>
                </div>
                <div class="col d-flex justify-content-start">
                <div class="qr-code-img d-none d-lg-inline me-3">
                    <img src="@/sass-template/content/images/qr-code.svg" class="img-fluid" alt="">
                </div>
                    <div class="download-stores">
                        <img src="@/sass-template/content/images/app-store.svg" class="img-fluid d-block" alt="" v-if="isDesktop || (isIOS && !isDesktop)"  @click="onAppStoreClick">
                        <img src="@/sass-template/content/images/google-play-store.svg" class="img-fluid d-lg-inline d-block mt-1" alt="" v-if="isDesktop || (isAndroid && !isDesktop)" @click="onPlayStoreClick">
                    </div>
                </div>
                <img src="@/sass-template/content/images/phone.svg" class="img-fluid mt-5 d-none d-lg-inline phone-img" alt="">
            </div>
        </div>
    </div>
  </div>
</template>

<script setup>
import {
  computed, onMounted, onUnmounted, ref,
} from 'vue';
import { useRouter } from 'vue-router';

const isIOS = ref(/iPad|iPhone|iPod/.test(navigator.userAgent));
const isAndroid = ref(/Android/.test(navigator.userAgent));
const isDesktop = ref(window.innerWidth > 768);
const router = useRouter();
const isAppOpened = ref(false);
const isIPhoneSafari = ref(isIOS.value && /Safari/i.test(navigator.userAgent));

const onAppStoreClick = () => {
  if (isDesktop.value) {
    window.open((process.env.VUE_APP_IPHONE_URL || ''), '_blank');
  } else {
    window.location.href = process.env.VUE_APP_IPHONE_URL || '';
  }
};
const onPlayStoreClick = () => {
  if (isDesktop.value) {
    window.open((process.env.VUE_APP_ANDROID_URL || ''), '_blank');
  } else {
    window.location.href = process.env.VUE_APP_ANDROID_URL || '';
  }
};

const userToken = computed(() => localStorage.getItem('authToken'));

const handleResize = () => {
  isDesktop.value = window.innerWidth > 768;
};

onMounted(() => {
  window.addEventListener('resize', handleResize);
});

onUnmounted(() => {
  window.removeEventListener('resize', handleResize);
});

const onOpenInCaseDrive = () => {
  if (!isDesktop.value && (isAndroid.value || isIOS.value)) {
    const appUrl = 'casedrive://';
    isAppOpened.value = false;

    if (isIPhoneSafari.value) {
      // Create an anchor element with the app URL
      const anchor = document.createElement('a');
      anchor.href = appUrl;

      // Attach an event listener to the blur event
      window.onblur = () => {
        isAppOpened.value = true;
      };

      // Append the anchor to the body
      document.body.appendChild(anchor);

      // Use the click method to simulate a user click
      anchor.click();
    } else {
      // Try to open the app using intent URL
      const opened = window.open(appUrl, '_self');
      // Define a function to handle focus
      opened.onblur = () => {
        isAppOpened.value = true;
      };
    }

    setTimeout(() => {
      // Check if the app was successfully opened
      if (!isAppOpened.value) {
        if (isIOS.value) {
          onAppStoreClick();
        } else {
          onPlayStoreClick();
        }
      }
    }, 2000);
  } else {
    // Redirect to the fallback URL for other platforms
    router.push({ name: 'Login' });
  }
};

</script>
